import { takeLatest, put, call } from 'redux-saga/effects';
import {  FETCH_CUG_PORTFOLIO_LIST_REQUEST, fetchCUGPortfolioResponse,
    FETCH_CUG_PAYMENTSCORE_DATA_REQUEST,FETCH_CUG_PAYMENTSCORE_DATA_BY_BUSINESS_TYPE_REQUEST, fetchCUGPaymentScoreDataResponse,
    FETCH_MONTHS_FILTERS, fetchMonthsFilter,FETCH_CUG_PORTFOLIO_LIST_SEARCH_REQUEST,
    FETCH_BREAKUP_OF_BUSINESS_DATA_REQUEST, fetchBreakupBusinessDataResponse,
    FETCH_CUG_LIST_REQUEST, fetchCUGListResponse, UPLOAD_CUG_DATA_REQUEST, uploadCUGDataResponse
} from './action';
import { CORE_API } from '../../../config';
import { HTTP_HEADERS } from '../../../constants'
import request from "../../../components/Utils/httpHelper";


export function* fetchCUGPortfolio(action){
    let requestURL = `${CORE_API}/cug/cug-list/${action.data}`;
    try {
        const cugPortfolioData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchCUGPortfolioResponse(cugPortfolioData.data))
    }
    catch (err) {
        yield put(fetchCUGPortfolioResponse(err))
    }
}

export function* fetchCUGPortfolioList() {
    yield takeLatest(FETCH_CUG_PORTFOLIO_LIST_REQUEST, fetchCUGPortfolio);
}



export function* fetchCUGPaymentScoreData(action){
    let requestURL = `${CORE_API}/cug/data/report/${action.data.corporateId}/${action.data.counterpartyId}/${action.data.cugId}`;
    try {
        const cugPortfolioData = yield call(request, requestURL, { method: 'GET', params : {"startDate" : action.data.startDate, "endDate" : action.data.endDate},  headers: HTTP_HEADERS });
        yield put(fetchCUGPaymentScoreDataResponse({ data : cugPortfolioData.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchCUGPaymentScoreDataResponse( { data : err , status : "FAILURE"}))
    }
}

export function* fetchCUGPaymentScoreDataRequest() {
    yield takeLatest(FETCH_CUG_PAYMENTSCORE_DATA_REQUEST, fetchCUGPaymentScoreData);
}



export function* fetchCUGPortfolioListBySearchRequest(action){
    let requestURL = `${CORE_API}/cug/portfolio/${action.data.pageNumber}/10`;
    try {
        const cugPortfolioData = yield call(request, requestURL, { method: 'POST', data: action.data.requestData, headers: HTTP_HEADERS });
        yield put(fetchCUGPortfolioResponse(cugPortfolioData.data));
    }
    catch (err) {
        yield put(fetchCUGPortfolioResponse(err));
    }
}

export function* fetchCUGPortfolioListBySearch() {
    yield takeLatest(FETCH_CUG_PORTFOLIO_LIST_SEARCH_REQUEST, fetchCUGPortfolioListBySearchRequest);
}


export function* fetchCUGPaymentScoreDataByBusinessType(action){
    let requestURL = `${CORE_API}/cug/cug-list`;
    try {
        const cugPortfolioData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchCUGPaymentScoreDataResponse({ data : cugPortfolioData.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchCUGPaymentScoreDataResponse( { data : err , status : "FAILURE"}))
    }
}

export function* fetchCUGPaymentScoreDataByBuisnessTypeRequest() {
    yield takeLatest(FETCH_CUG_PAYMENTSCORE_DATA_BY_BUSINESS_TYPE_REQUEST, fetchCUGPaymentScoreDataByBusinessType);
}


export function* fetchMonthsFilterRequest(action){
    let requestURL = `${CORE_API}/cug/cug-list`;
    try {
        const cugPortfolioData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchMonthsFilter({ data : cugPortfolioData.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchMonthsFilter( { data : err , status : "FAILURE"}))
    }
}

export function* fetchMonthFilter() {
    yield takeLatest(FETCH_MONTHS_FILTERS, fetchMonthsFilterRequest);
}



export function* fetchBreakupOfBusinessData(action){
    let requestURL = `${CORE_API}/cug/cug-list`;
    try {
        const cugPortfolioData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchBreakupBusinessDataResponse({ data : cugPortfolioData.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchBreakupBusinessDataResponse( { data : err , status : "FAILURE"}))
    }
}

export function* fetchBreakupOfBusinessRequest() {
    yield takeLatest(FETCH_MONTHS_FILTERS, fetchBreakupOfBusinessData);
}


export function* fetchCUGListServerRequest(action){
    let requestURL = `${CORE_API}/cug/list`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchCUGListResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchCUGListResponse( { data : err , status : "FAILURE"}))
    }
}

export function* fetchCUGList() {
    yield takeLatest(FETCH_CUG_LIST_REQUEST, fetchCUGListServerRequest);
}

//UPLOAD_CUG_DATA_REQUEST


export function* uploadCUGDataRequest(action){
    let requestURL = `${CORE_API}/cug/data/upload`;
    const formData = new FormData();
    formData.append('cugId', action.data.cugId)
    formData.append('file', action.data.file);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS });
        yield put(uploadCUGDataResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(uploadCUGDataResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* uploadCUGData() {
    yield takeLatest(UPLOAD_CUG_DATA_REQUEST, uploadCUGDataRequest);
}